import { Alignment, LeftOrRightAlignment } from "@mcleod/core";
import { AbstractGeneratedColumnHandler } from "./AbstractGeneratedColumnHandler";
import { DesignerToolsTableCell } from "./DesignerToolsTableCell";
import { DesignerToolsTableColumn } from "./DesignerToolsTableColumn";
import { TableCell } from "./TableCell";
import { TableRow } from "./TableRow";

export class DesignerToolsHandler extends AbstractGeneratedColumnHandler {
    protected override createColumn(): DesignerToolsTableColumn {
        return new DesignerToolsTableColumn({ table: this.table });
    }

    protected override get columnAlignment(): LeftOrRightAlignment {
        return Alignment.RIGHT;
    }

    protected override getLogPath(): string {
        return "components.table.DesignerToolsHandler";
    }

    protected override createPlaceholderCell(tableRow: TableRow): TableCell {
        return new DesignerToolsTableCell({ table: this.table, row: tableRow });
    }
}
